<template>
  <v-container
    class="cmpbkinside black--text mt-4 px-3 pb-10"
    id="tsep-container"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <h3 class="">TSEP Form</h3>
    <hr />

    <v-form>
      <v-row id="grant">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.grant_type"
            label="Grant Type"
            maxlength="60"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.event_no"
            label="(JF Only) Event #"
            maxlength="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row id="ofcr-name" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.officer_name"
            label="Officer Name(Last,First)"
            maxlength="120"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.id_no"
            label="ID #"
            maxlength="10"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row id="dept" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1"
            v-model="tsep_form.officer_dept"
            label="Department"
            maxlength="60"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row id="date-day" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.frm_date"
            label="Date"
            maxlength="10"
            placeholder="##/##/##"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.day"
            label="Day of Week"
            maxlength="25"
          ></v-text-field>
        </v-col>
      </v-row>
      <div>
        <span>24 HR format</span>
      </div>
      <v-row id="time" class="mt-n4">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.start_time"
            label="Start time"
            maxlength="4"
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.end_time"
            label="End Time"
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.hours"
            label="Hours"
            maxlength="4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row id="time-chkbx" class="d-flex flex-row mt-n11 mb-6">
        <v-col cols="2">
          <v-checkbox v-model="tsep_form.ot_chkbx" label="OT"></v-checkbox>
        </v-col>
        <v-col cols="2">
          <v-checkbox v-model="tsep_form.rt_chkbx" label="RT"></v-checkbox>
        </v-col>
      </v-row>

      <div cols="12" class="main-title mb-2 mt-4">
        <span><strong>CITATIONS, ARRESTS & WARNINGS</strong></span>
        <hr />
      </div>

      <!-- impaired -->
      <div>
        <span><strong>Impaired Driving - DUI arrest</strong></span>
      </div>
      <v-row id="dui-arrest" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <!-- total needs the two models and the one to be totaled. -->
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.dui_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('dui_arrest', $event)"
            @focus="getfocus($event)"
            @change="total('dui_arrest', null, 'dui_arr_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.dui_arr_total"
            label="Total"
            type="number"
            min="0"
            max="20"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <div>
        <span><strong>Impaired Driving - DUI assist</strong></span>
      </div>
      <v-row id="dui-assist" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.dui_assist"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('dui_assist', $event)"
            @focus="getfocus($event)"
            @change="total('dui_assist', null, 'dui_ass_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.dui_ass_total"
            label="Total"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- OP -->
      <div>
        <span><strong>OP-Seat Belt</strong></span>
      </div>
      <v-row id="op-seat-arrest" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.op_seat_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('op_seat_arrest', $event)"
            @focus="getfocus($event)"
            @change="total('op_seat_arrest', null, 'op_seat_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.op_seat_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <div>
        <span><strong>OP - Child Seat</strong></span>
      </div>
      <v-row id="op-child-arrest" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.op_child_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('op_child_arrest', $event)"
            @focus="getfocus($event)"
            @change="total('op_child_arrest', null, 'op_child_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.op_child_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Speed -->
      <div>
        <span><strong>Speed</strong></span>
      </div>
      <v-row id="speed" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.speed_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('speed_arrest', $event)"
            @focus="getfocus($event)"
            @change="total('speed_arrest', 'speed_warnings', 'speed_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.speed_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('speed_warnings', $event)"
            @focus="getfocus($event)"
            @change="total('speed_warnings', 'speed_arrest', 'speed_total')"
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.speed_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- pedestrian -->
      <div>
        <span><strong>Pedestrian - Pedestrian at Fault</strong></span>
      </div>
      <v-row id="pedestrian-fault" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.ped_fault_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('ped_fault_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total('ped_fault_arrest', 'ped_fault_warnings', 'ped_fault_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.ped_fault_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('ped_fault_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total('ped_fault_warnings', 'ped_fault_arrest', 'ped_fault_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.ped_fault_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <div>
        <span><strong>Pedestrian - Driver at Fault</strong></span>
      </div>
      <v-row id="driver-fault" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.driver_fault_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('driver_fault_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'driver_fault_arrest',
                'driver_fault_warnings',
                'driver_fault_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.driver_fault_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('driver_fault_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'driver_fault_warnings',
                'driver_fault_arrest',
                'driver_fault_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.driver_fault_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Distrcted driving -->
      <div>
        <span><strong>Distracted Driving</strong></span>
      </div>
      <v-row id="dist-drive" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.dist_drive_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('dist_drive_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'dist_drive_arrest',
                'dist_drive_warnings',
                'dist_drive_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.dist_drive_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('dist_drive_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'dist_drive_warnings',
                'dist_drive_arrest',
                'dist_drive_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.dist_drive_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- All other citations -->
      <div class="mb-2">
        <span><strong>ALL OTHER CITATIONS</strong></span>
        <hr />
      </div>
      <div>
        <span><strong>DL Violations</strong></span>
      </div>
      <v-row id="dl-violations" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.dl_violation_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('dl_violation_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'dl_violation_arrest',
                'dl_violation_warnings',
                'dl_violation_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.dl_violation_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('dl_violation_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'dl_violation_warnings',
                'dl_violation_arrest',
                'dl_violation_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.dl_violation_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- equipment violations -->
      <div>
        <span><strong>Equipment Violations</strong></span>
      </div>
      <v-row id="equip-violation" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.eqip_violations_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('eqip_violations_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'eqip_violations_arrest',
                'eqip_violations_warnings',
                'eqip_violations_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.eqip_violations_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('eqip_violations_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'eqip_violations_warnings',
                'eqip_violations_arrest',
                'eqip_violations_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.eqip_violations_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- no insurance -->
      <div>
        <span><strong>No Insurance</strong></span>
      </div>
      <v-row id="no-ins" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.no_ins_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('no_ins_arrest', $event)"
            @focus="getfocus($event)"
            @change="total('no_ins_arrest', 'no_ins_warnings', 'no_ins_total')"
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.no_ins_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('no_ins_warnings', $event)"
            @focus="getfocus($event)"
            @change="total('no_ins_warnings', 'no_ins_arrest', 'no_ins_total')"
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.no_ins_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Reckless Driving -->
      <div>
        <span><strong>Reckless Driving</strong></span>
      </div>
      <v-row id="reckls-drive" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.reckls_drive_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('reckls_drive_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'reckls_drive_arrest',
                'reckls_drive_warnings',
                'reckls_drive_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.reckls_drive_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('reckls_drive_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total(
                'reckls_drive_warnings',
                'reckls_drive_arrest',
                'reckls_drive_total'
              )
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.reckls_drive_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Red Light Running -->
      <div>
        <span><strong>Red Light Running</strong></span>
      </div>
      <v-row id="red-light" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.red_light_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('red_light_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total('red_light_arrest', 'red_light_warnings', 'red_light_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.red_light_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('red_light_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total('red_light_warnings', 'red_light_arrest', 'red_light_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.red_light_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Failure to Yield -->
      <div>
        <span><strong>Failure to Yield</strong></span>
      </div>
      <v-row id="fail-yld" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.fail_yld_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('fail_yld_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total('fail_yld_arrest', 'fail_yld_warnings', 'fail_yld_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.fail_yld_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('fail_yld_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total('fail_yld_warnings', 'fail_yld_arrest', 'fail_yld_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.fail_yld_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- Other Citations -->
      <div>
        <span><strong>Other Citations</strong></span>
      </div>
      <v-row id="other-cit" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.other_cit_arrest"
            label="# Citations or arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('other_cit_arrest', $event)"
            @focus="getfocus($event)"
            @change="
              total('other_cit_arrest', 'other_cit_warnings', 'other_cit_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-2 mr-1"
            v-model="tsep_form.other_cit_warnings"
            label="# Warnings"
            type="number"
            min="0"
            max="20"
            @click="add_one('other_cit_warnings', $event)"
            @focus="getfocus($event)"
            @change="
              total('other_cit_warnings', 'other_cit_arrest', 'other_cit_total')
            "
          ></v-text-field>
          <v-text-field
            class="tf-3"
            v-model="tsep_form.other_cit_total"
            label="Total"
            type="number"
            min="0"
            max="20"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- TOTAL ROW -->
      <div style="border: 3px solid black" class="mb-4">
        <div>
          <span class="mx-2"><strong>TOTAL:</strong></span>
        </div>
        <v-row class="mx-1">
          <v-col cols="12" class="d-flex flex-row">
            <v-text-field
              class="tf-1 mr-1"
              v-model="tsep_form.total_cit"
              label="Total Citations or arrests"
              type="number"
              min="0"
              max="200"
            ></v-text-field>
            <v-text-field
              class="tf-2 mr-1"
              v-model="tsep_form.total_warn"
              label="Total Warnings"
              type="number"
              min="0"
              max="200"
            ></v-text-field>
            <v-text-field
              class="tf-3"
              v-model="tsep_form.total_total"
              label="Total"
              type="number"
              min="0"
              max="200"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <hr />

      <!-- Additional Enforcement Information -->
      <div>
        <span><strong>Additional Enforcement Information</strong></span>
      </div>
      <v-row id="add-info" class="mt-0">
        <v-col cols="12" class="d-flex flex-row">
          <v-text-field
            class="tf-1 mr-1"
            v-model="tsep_form.total_contacts"
            label="Total # of contacts*"
            type="number"
            min="0"
            max="20"
            @click="add_one('total_contacts', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-2"
            v-model="tsep_form.total_arrests"
            label="Total # of arrests"
            type="number"
            min="0"
            max="20"
            @click="add_one('total_arrests', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="text--secondary mt-n7 mb-4" style="font-size: smaller">
        <span>*At least 2 contacts per hour is highly encouraged</span>
      </div>
      <!-- Education Activities -->
      <div>
        <span><strong>EDUCATION ACTIVITIES</strong></span>
      </div>
      <hr />
      <v-row id="edu-activity" class="mt-0 flex-sm-nowrap">
        <v-col cols="12" class="d-flex flex-column">
          <v-text-field
            class="tf-100 mr-1"
            v-model="tsep_form.driver_ed"
            label="# of drivers educated during contact"
            type="number"
            min="0"
            max="20"
            @click="add_one('driver_ed', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.edu_materials"
            label="# of educational materials distributed"
            type="number"
            min="0"
            max="20"
            @click="add_one('edu_materials', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100 mr-1"
            v-model="tsep_form.comm_pres"
            label="# of community presentations conducted"
            type="number"
            min="0"
            max="20"
            @click="add_one('comm_pres', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.press_conf"
            label="# of press conferences attended/conducted"
            type="number"
            min="0"
            max="20"
            @click="add_one('press_conf', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.social_media"
            label="# of grant-related social media posts, shares, tweets, retweets"
            type="number"
            min="0"
            max="20"
            @click="add_one('social_media', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- IMPARED DRIVING  -->
      <div>
        <span><strong>IMPARED DRIVING</strong></span>
      </div>
      <hr />
      <v-row id="impaired-driving" class="mt-0 flex-sm-nowrap">
        <v-col cols="12" class="d-flex flex-column">
          <v-text-field
            class="tf-100 mr-1"
            v-model="tsep_form.impaired_crash"
            label="# of impaired driving crashes"
            type="number"
            min="0"
            max="20"
            @click="add_one('impaired_crash', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.pbt_administered"
            label="# of PBT's administered"
            type="number"
            min="0"
            max="20"
            @click="add_one('pbt_administered', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100 mr-1"
            v-model="tsep_form.sfst_conducted"
            label="# of SFST's conducted"
            type="number"
            min="0"
            max="20"
            @click="add_one('sfst_conducted', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.dre_eval"
            label="# of DRE evals conducted"
            type="number"
            min="0"
            max="20"
            @click="add_one('dre_eval', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.cannabis"
            label="# suspected using cannabis"
            type="number"
            min="0"
            max="20"
            @click="add_one('cannabis', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.interlock_ign"
            label="# of interlock ignition devices"
            type="number"
            min="0"
            max="20"
            @click="add_one('interlock_ign', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
          <v-text-field
            class="tf-100"
            v-model="tsep_form.dui_blood"
            label="# of DUI blood search warrants"
            type="number"
            min="0"
            max="20"
            @click="add_one('dui_blood', $event)"
            @focus="getfocus($event)"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- OFFICER CERTIFICATIONS -->
      <div class="d-flex flex-column">
        <span class="tf-100"><strong>OFFICER CERTIFICATIONS</strong></span>
        <span class="tf-100">Check all that apply</span>
      </div>
      <v-row class="d-flex flex-row ofcr-cert-chkbx">
        <v-col cols="4">
          <v-checkbox v-model="tsep_form.sfst" label="SFST"></v-checkbox>
        </v-col>
        <v-col cols="4">
          <v-checkbox v-model="tsep_form.aride" label="ARIDE"></v-checkbox>
        </v-col>
        <v-col cols="4">
          <v-checkbox v-model="tsep_form.dre" label="DRE"></v-checkbox>
        </v-col>
      </v-row>
      <v-row class="d-flex flex-column mt-0 other-chkbox">
        <v-col cols="12" class="ofcr-cert-chkbx">
          <v-checkbox v-model="tsep_form.other" label="Other*"></v-checkbox>
        </v-col>
        <v-textarea
          class="other-texta pt-0 pb-4"
          label="*if other, please list"
          v-model="tsep_form.other_list"
          rows="2"
          row-height="15"
          auto-grow
          max-length="200"
        ></v-textarea>
        <span
          style="font-size: smaller; width: 96%; margin: 0 auto"
          class="mb-2"
          >Use the space below to document anything you want to share that
          occured during the activity</span
        >
        <v-textarea
          class="other-texta pt-0 pb-10"
          label="Comments "
          v-model="tsep_form.note"
          rows="6"
          row-height="15"
          auto-grow
          max-length="200"
        ></v-textarea>
      </v-row>

      <!-- end form -->
    </v-form>
    <div id="footer_cont" class="d-flex flex-row justify-center">
      <div class="footer blue darken-4">
        <v-btn id="fabsave" elevation="2" color="cmpbk" fab @click="save_tesp()"
          ><v-icon class="white--text">$save</v-icon></v-btn
        >
        <v-btn id="fabdown" elevation="2" color="cmpbk" fab @click="scrolltop"
          ><v-icon class="white--text">$chevup</v-icon></v-btn
        >
        <v-btn id="fabup" elevation="2" color="cmpbk" fab @click="scrollbtm"
          ><v-icon class="white--text">$chevdown</v-icon></v-btn
        >
      </div>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  #footer_cont {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 45px;
    z-index: 4000;
    background-color: transparent;
  }
  .footer {
    width: 100%;
    max-width: 768px;
    min-height: 45px;
    text-align: center;
  }
  .cmpbkinside {
    width: 96vw;
    height: auto;
  }

  #grant .tf-1,
  #date-day .tf-1 {
    width: 50%;
  }

  #grant .tf-2,
  #date-day .tf-2 {
    width: 50%;
  }

  #ofcr-name .tf-1 {
    width: 75%;
  }
  #ofcr-name .tf-2 {
    width: 25%;
  }

  #speed .tf-1,
  #speed .tf-2,
  #speed .tf-3 {
    width: 33%;
  }

  #edu-activity .tf-100 {
    width: 100%;
  }

  .tf-100 {
    width: 100%;
  }

  .other-texta {
    width: 96%;
    margin: 0 auto;
  }

  .ofcr-cert-chkbx,
  #time-chkbx {
    height: 65px;
  }

  /*   .other-chkbox >>> .v-text-field__slot textarea {
    line-height: 0.75rem !important;
  } */
}

/* 768 media q */
@media (min-width: 768px) {
  #footer_cont {
    position: fixed;
    left: -8px;
    bottom: 0;
    width: 100%;
    min-height: 45px;
    z-index: 4000;
    background-color: transparent;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
  .cmpbkinside {
    width: 768px;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "tsep_form",
  mixins: [bus_common],
  props: ["tsep_fromId"],
  data() {
    return {
      tsep_form: {
        grant_type: "grant_type",
        event_no: "event_no",
        officer_name: "officer_name",
        id_no: "id_no",
        officer_dept: "officer_dept",
        frm_date: "01/01/2024",
        day: "",
        start_time: "",
        end_time: "",
        hours: 0,
        ot_chkbx: false,
        rt_chkbx: false,
        dui_arrest: 0,
        dui_arr_total: 0,
        dui_assist: 0,
        dui_ass_total: 0,
        op_seat_arrest: 0,
        op_seat_total: 0,
        op_child_arrest: 0,
        op_child_total: 0,
        speed_arrest: 0,
        speed_warnings: 0,
        speed_total: 0,
        ped_fault_arrest: 0,
        ped_fault_warnings: 0,
        ped_fault_total: 0,
        driver_fault_arrest: 0,
        driver_fault_warnings: 0,
        driver_fault_total: 0,
        dist_drive_arrest: 0,
        dist_drive_warnings: 0,
        dist_drive_total: 0,
        dl_violation_arrest: 0,
        dl_violation_warnings: 0,
        dl_violation_total: 0,
        eqip_violations_arrest: 0,
        eqip_violations_warnings: 0,
        eqip_violations_total: 0,
        no_ins_arrest: 0,
        no_ins_warnings: 0,
        no_ins_total: 0,
        reckls_drive_arrest: 0,
        reckls_drive_warnings: 0,
        reckls_drive_total: 0,
        red_light_arrest: 0,
        red_light_warnings: 0,
        red_light_total: 0,
        fail_yld_arrest: 0,
        fail_yld_warnings: 0,
        fail_yld_total: 0,
        other_cit_arrest: 0,
        other_cit_warnings: 0,
        other_cit_total: 0,
        total_cit: 0,
        total_warn: 0,
        total_total: 0,
        total_contacts: 0,
        total_arrests: 0,
        driver_ed: 0,
        edu_materials: 0,
        comm_pres: 0,
        press_conf: 0,
        social_media: 0,
        impaired_crash: 0,
        pbt_administered: 0,
        sfst_conducted: 0,
        dre_eval: 0,
        cannabis: 0,
        interlock_ign: 0,
        dui_blood: 0,
        sfst: false,
        aride: false,
        dre: false,
        other: 0,
        other_list: "",
        note: "",
      },

      lst_grants: [],
    };
  },

  methods: {
    grand_total() {
      console.log("grand_total");
      this.tsep_form.total_warn =
        parseInt(this.tsep_form.speed_warnings) +
        parseInt(this.tsep_form.ped_fault_warnings) +
        parseInt(this.tsep_form.ped_fault_warnings) +
        parseInt(this.tsep_form.driver_fault_warnings) +
        parseInt(this.tsep_form.dist_drive_warnings) +
        parseInt(this.tsep_form.dl_violation_warnings) +
        parseInt(this.tsep_form.eqip_violations_warnings) +
        parseInt(this.tsep_form.no_ins_warnings) +
        parseInt(this.tsep_form.no_ins_warnings) +
        parseInt(this.tsep_form.reckls_drive_warnings) +
        parseInt(this.tsep_form.red_light_warnings) +
        parseInt(this.tsep_form.fail_yld_warnings) +
        parseInt(this.tsep_form.other_cit_warnings);

      this.tsep_form.total_cit =
        parseInt(this.tsep_form.dui_arrest) +
        parseInt(this.tsep_form.dui_assist) +
        parseInt(this.tsep_form.op_seat_arrest) +
        parseInt(this.tsep_form.speed_arrest) +
        parseInt(this.tsep_form.ped_fault_arrest) +
        parseInt(this.tsep_form.driver_fault_arrest) +
        parseInt(this.tsep_form.dist_drive_arrest) +
        parseInt(this.tsep_form.dl_violation_arrest) +
        parseInt(this.tsep_form.eqip_violations_arrest) +
        parseInt(this.tsep_form.no_ins_arrest) +
        parseInt(this.tsep_form.reckls_drive_arrest) +
        parseInt(this.tsep_form.red_light_arrest) +
        parseInt(this.tsep_form.fail_yld_arrest) +
        parseInt(this.tsep_form.other_cit_arrest);

      this.tsep_form.total_total =
        parseInt(this.tsep_form.total_warn) +
        parseInt(this.tsep_form.total_cit);
    },
    total(fldname1, fldname2, totlfld) {
      //this.mrbreakpoint(totlfld);
      console.log("changed " + fldname1, this.tsep_form[totlfld]);
      if (fldname2 == null) {
        this.tsep_form[totlfld] = this.tsep_form[fldname1];
      } else {
        this.tsep_form[totlfld] =
          this.tsep_form[fldname1] + this.tsep_form[fldname2];
      }
    },
    getfocus(e) {
      //  this.mrbreakpoint(e);
      console.log(e.target);
      var inpt = e.target;
      inpt.select();
    },
    add_one(fldname, e) {
      // this.mrbreakpoint(fldname);
      this.tsep_form[fldname] = parseInt(this.tsep_form[fldname]) + 1;
      setTimeout(() => {
        console.log("add_one_focus: " + this.tsep_form[fldname]);
        var inpt = e.target;
        inpt.select();
        this.grand_total();
      }, 200);
    },
    save_tesp(id) {
      // this.mrbreakpoint(stat);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.tsep_form = this.tsep_form;
      formIn.tsep_form.tsep_fromId = this.tsep_fromId;
      var nowish = Date();
      formIn.tsep_form.frm_date = this.format_date_us(nowish);
      formIn.apiname = "save_tesp";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.swall_it(
            "Save TSEP Form Status",
            "Completed.",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    scrollbtm() {
      console.log("btm: " + document.getElementById("vapp").scrollHeight);
      document.getElementById("vapp").scrollTop =
        document.getElementById("vapp").scrollHeight;
    },
    scrolltop() {
      document.getElementById("vapp").scrollTop = 0;
    },
    message1() {
      alert("This button does nothing yet.");
    },
    set_frm_new_values() {
      var dt = this.$moment(new Date()).local();
      this.tsep_form.frm_date = this.format_date_us(dt);
      this.tsep_form.day = this.get_day_of_week(dt);
      this.tsep_form.start_time = this.get_rpd_time_str(dt);
      this.tsep_form.end_time = this.get_rpd_time_str(dt);
    },
    get_grants() {
      //get grants

      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_grants";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_grants = self.mno(data);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Getting Grants", msg, "error", null, null);
        });
    },
    init() {
      this.set_frm_new_values();
    },
  },
  mounted() {
    this.show_loader(false);
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
